export default {"src":"/_next/static/media/handshake.4d568c13.svg","height":252,"width":400};